if (import.meta.env.DEV) {
  const { scan } = await import("react-scan")
  scan({ enabled: true })
  await import("react-grab")
}

await import("./render-app.tsx")
